import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from '../../../../core/modelos/cliente';
import { fuseAnimations } from '../../../../core/animations';
import { ClientesService } from '../clientes.service';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';

@Component({
    selector: 'fuse-clientes-editar',
    templateUrl: './clientes-editar.component.html',
    styleUrls: ['./clientes-editar.component.scss'],
    animations: fuseAnimations
})
export class ClientesEditarComponent implements OnInit {

    cliente: Cliente;
    idCliente: number;

    // Variable que indica si estamos editando o creando.
    editando = false;
    loading = true;

    // Validación del servidor
    validacion: any;

    // Formulario
    formulario: FormGroup;

    ocultar = true;

    selectedFiles: FileList;
    imagen;

    linkPattern: RegExp = /^https?:\/\/.+$/;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private clientesService: ClientesService,
        private notificaciones: NotificacionesService
    ) {
        // Traigo el cliente por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idCliente = params['idCliente'];
        });
    }

    ngOnInit() {

        this.init();

    }

    init() {

        if (this.idCliente) {
            this.editando = true;
            this.getCliente(this.idCliente); // TODO: Suscribir para redirigir si no existe

        } else {
            // console.log('añadiendo...');
            this.loading = false;
            this.crearFormulario();
        }
    }

    getCliente(id: number) {
        this.clientesService.getCliente(id).subscribe(
            data => {
                if (data.success) {
                    this.cliente = data.items;
                    this.cliente.logo = this.cliente.logo ? 'data:image/jpeg;base64,' + this.cliente.logo : this.cliente.logo;
                    this.loading = false;
                    this.crearFormulario();
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteNOObtenido);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    crearFormulario() {

        if (this.editando) {
            
            this.formulario = this.fb.group({
                nombre: [this.cliente.nombre, Validators.required],
                email: [this.cliente.email],
                codigo: [this.cliente.codigo, Validators.required],
                usuarios_totales: [this.cliente.usuarios_totales, Validators.required],
                max_proyectos: [this.cliente.max_proyectos, Validators.required],
                usuarioAWS: [this.cliente.userAWS, Validators.required],
                passwordAWS: [this.cliente.passwordAWS, Validators.required],
                bucketAWS: [this.cliente.bucketAWS, Validators.required],
                powerBI: [this.cliente.general_powerbi, Validators.required],
                hide_filters: [this.cliente.hide_filters, Validators.required],
            });
        }
        else {
            this.formulario = this.fb.group({
                nombre: ['', Validators.required],
                email: [''],
                codigo: ['', Validators.required],
                usuarios_totales: ['', Validators.required],
                max_proyectos: ['', Validators.required],
                usuarioAWS: ['', Validators.required],
                passwordAWS: ['', Validators.required],
                bucketAWS: ['', Validators.required],
                powerBI: ['', Validators.required],
                hide_filters: [true, Validators.required],
            });
        }

    }

    compare(val1, val2) {
        return val1.id === val2.id;
    }

    actualizarPag(event: boolean) {
        if (event) {
            this.init();
        }
    }
    selectFile(event) {
        // Recoge la imagen que quiere subir el usuario y la guardo en this.imagen con el formato adecuado
        this.selectedFiles = event.target.files;
        const reader = new FileReader();
        const file = this.selectedFiles.item(0);
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.imagen = reader.result.split(',')[1];
            this.cliente.logo = 'data:image/jpeg;base64,' + this.imagen; // Para que actualice en pantalla también
        };

    }

    onSubmit(): void {
        this.cliente = this.prepararModelo();

        // Hay que subirlo sin el 'data:image/jpeg;base64,'
        this.cliente.logo = this.imagen;
        if (this.editando) {
            this.clientesService.updateCliente(this.cliente).subscribe(
                data => {
                    if (data.success) {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteEditado);
                        this.router.navigate(['/clientes/detalle', this.cliente.id]);
                        // this.init();
                        // TODO: Alerta de centro actualizado
                    } else if (data.message) {
                        this.validacion = data.message;
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteNOEditado);
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                    // if (err.error.message) {
                    //     this.validacion = err.error.message;
                    // }
                }
            );

        } else {
            this.clientesService.addCliente(this.cliente).subscribe(
                data => {
                    if (data.success) {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteCreado);
                        this.router.navigate(['/clientes/detalle', data.items.id]);
                        // this.init();
                    } else if (data.message) {
                        this.validacion = data.message;
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteNOCreado);
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                    // console.error(err);
                    // if (err.error.message) {
                    //     this.validacion = err.error.message;
                    // }
                }
            );
        }
    }

    prepararModelo(): Cliente {
        const formModel = this.formulario.value;

        const savecliente: Cliente = {
            id: this.cliente ? this.cliente.id : undefined,
            nombre: formModel.nombre,
            email: formModel.email,
            codigo: formModel.codigo,
            usuarios_totales: formModel.usuarios_totales,
            max_proyectos: formModel.max_proyectos,
            userAWS: formModel.usuarioAWS,
            passwordAWS: formModel.passwordAWS,
            bucketAWS: formModel.bucketAWS,
            general_powerbi: formModel.powerBI,
            hide_filters: formModel.hide_filters,
        };

        return savecliente;
    }


}



// WEBPACK FOOTER //
// ./src/app/main/content/clientes/editar/clientes-editar.component.ts